export default {
  slug: 'indicators',
  title: 'Indicators',
  description: 'Observable registry, confidence, and enrichment linkage.',
  section: 'investigations',
  order: 2,
  tags: ['indicators', 'ioc', 'registry'],
  body: `# Indicators

The **indicator registry** is the platform-wide list of observables — IPs, domains, emails, wallets, hashes, and more.

## Registry view

**[Investigations → Indicators](/indicators)** supports:

- Full-text filter across value, type, and case title
- Type filter dropdown
- Case filter dropdown
- Clickable pivot links on value and case columns

## Indicator detail

Each indicator opens a detail page with:

- **Overview** — type, value, normalized form, source, confidence, linked case/actor chips
- **Relationships** — stored and implicit links
- **Enrichment** — snapshots from linked intelligence searches
- **Raw** — JSON export

### Quick actions (sidebar)

- **Run enrichment** — starts a new search on the indicator value
- **Show graph** — investigation graph centered on this indicator
- **Linked case** — pivot to parent case when attached

## Sources

Indicators may originate from:

| Source | Description |
|--------|-------------|
| \`intelligence_search\` | Promoted from enrichment |
| \`indicator_extractor\` | Promoted from pasted text |
| Manual / evidence | Created via evidence vault or API |

Promoted indicators store \`metadata.search_query_id\` when applicable.

## Confidence levels

Set at promotion time: **low**, **medium**, or **high**. Use consistent thresholds across your team (e.g. high = ready for client disclosure, low = leads only).
`,
};
